/* eslint-disable simple-import-sort/imports */

import './CompteExpert.scss';

import React from 'react';
import DocAdministra from './SideExpertCompteExpert';

import NavBarDonneeProfile from './NavBarDonneeProfile';

import DonneeCvPartage from './DonneeCvPartage';
import { useLocation } from 'react-router-dom';
import { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import { useEffect } from 'react';
import { useState } from 'react';
import { axiosPrivate } from '../../../Api/axios';
import { getNomPrenomClearFromPersoData } from '../../../Utils/utils';
import useWindowSize from '../../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import useRole from '../../../hooks/useRole';

function DonneeCV() {
    const location = useLocation();
    const [nomExpert,setNomExpert]=useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const role=useRole();
    console.log('expert ID',location?.state?.expertId);
    console.log('location',location);

    const getClientbyId = async () => {
        try {
            // Regular expression pattern to match the id
            const idPattern = /\/gestionExperts\/([^/]+)\//;

            // Extract the id using match() method
            const match = location?.pathname.match(idPattern);
            // Extracted id will be in match[1]

            const id = match ? match[1] : null;
            const response = await axiosPrivate.get('/users/getExpertById/'+id);
            setNomExpert(getNomPrenomClearFromPersoData(response?.data?.persoData));
            console.log('response BE',response?.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getTypeTraitement = (role) => {
        const url = window.location.href; // Get the full URL
        if(role=='esn' && url.includes('gestionExperts'))
            return typeTraitementEnum.COLLAB_ESN_UPDATE_EXPERT;
        else if(role=='esn' && url.includes('gestionDossiersCandidats'))
            return typeTraitementEnum.COLLAB_ESN_UPDATE_DOSSIER_CANDIDAT;
        else
            return typeTraitementEnum.ADMIN_UPDATE_EXPERT;
    };

    useEffect(() => {
        if(location)
            getClientbyId();
    }, [location]);
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Gestion des Experts')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{nomExpert} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <DocAdministra
                        type={location?.state?.type}
                        role={role}
                    />
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center',gap:'24px'}}>
                        <NavBarDonneeProfile
                            type={location?.state?.type}
                            role={role}
                        />
                        {role &&
                            <DonneeCvPartage
                                // typeTraitement={(location?.state?.type=='Actif'||typeof location?.state?.type=='undefined' )?
                                // typeTraitementEnum.READ_ONLY : typeTraitementEnum.ADMIN_UPDATE_EXPERT}
                                //d'apres la demande de FZ -> Modifiez la logique de cette partie pour permettre à BO de modifier les données, même si l'expert est actif est actif.
                                typeTraitement={getTypeTraitement(typeTraitementEnum)}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
}
export default DonneeCV;

